"use client";

import { useRouter } from "next/navigation";
import { memo } from "react";

import { routes } from "#/config/routes";
import { useMarket } from "#/store/app/portfolio/market";
import { useMaturity } from "#/store/options/page/maturity";
import { useOption } from "#/store/options/tradePanel/option";
import { type Option } from "#/types/options";
import {
  formatInstrumentName,
  getOptionInstrumentProperties,
  getPerpInstrumentProperties,
  isOptionInstrument,
} from "#/utils/instrument.utils";
import { getMarketByUnderlying } from "#/utils/marketPair";

export interface ClickableInstrumentProps {
  instrument: string;
}

const Instrument: React.FC<ClickableInstrumentProps> = ({ instrument }) => {
  const { setMarket } = useMarket();
  const { setMaturity } = useMaturity();
  const { setOption } = useOption();
  const router = useRouter();
  const isOption = isOptionInstrument(instrument);

  const handleNavigate = () => {
    if (isOption) {
      const { underlying, maturity, optionType, strike } =
        getOptionInstrumentProperties(instrument);
      const market = getMarketByUnderlying(underlying);
      const option: Option = {
        instrument_name: instrument,
        isBuy: true,
        isCall: optionType === "call",
        underlying,
        direction: "buy",
        maturity,
        strike: Number(strike),
        marketPair: market.pair,
      };
      setOption(option);
      setMarket(market);
      setMaturity(maturity);
      router.push(routes.options());
    } else {
      const { underlying } = getPerpInstrumentProperties(instrument);
      const market = getMarketByUnderlying(underlying);
      setMarket(market);
      router.push(routes.perps);
    }
  };

  return (
    <button className="cursor-pointer hover:underline" onClick={handleNavigate}>
      {formatInstrumentName(instrument)}
    </button>
  );
};

export const ClickableInstrument = memo(Instrument);
